import React from "react";
import {Link} from "react-router-dom";
import logo from "@/assets/logo.svg";
import buymeacoffeeIcon from "@/assets/buymeacoffee-icon.svg";
import "../styles/Footer.css";
import "../styles/main.css";

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={logo} alt="League of Fabled Pursuits Logo" />
          </div>
        </div>

        <div className="footer-sections">
          <div className="footer-section">
            <h3>Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/rules">Rules</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Socials</h3>
            <ul>
              <li>
                <a
                  href="https://www.instagram.com/the_l.f.p/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Legal</h3>
            <ul>
              <li>
                <Link to="/legal/terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/legal/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/legal/conduct">Code of conduct</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-cta">
          <a
            href="https://buymeacoffee.com/fabledpursuits"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary support-us-btn"
          >
            <img src={buymeacoffeeIcon} alt="Coffee" />
            Support Us
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 League of Fabled Pursuits. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
